<template>
    <modal name="document-upload-folder-select-modal"
        :adaptive="true"
        :focusTrap="true"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-open="beforeOpen"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white px-10 py-8 max-h-[66vh] flex flex-col">
            <div class="flex-shrink-0 text-blue-600 text-lg font-semibold leading-none mb-6">
                Select the folder to upload your document to:
            </div>

            <!-- Scrollable content area -->
            <div class="flex-1 overflow-y-auto mb-4 min-h-0 border border-gray-200">
                <input-radio-multi
                    :options="folder_options"
                    :value="selected_folder_id"
                    @input="selected_folder_id = $event"
                    vertical="true"
                    size="small"
                    item_class="px-3 py-1.5 border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
                />
            </div>

            <!-- Error message -->
            <div v-if="error" class="text-red-600 font-semibold text-sm leading-tight mb-4 flex-shrink-0">
                {{ error }}
            </div>

            <!-- Buttons -->
            <div class="flex items-center justify-between pt-4 flex-shrink-0">
                <button-gray-outline @click="beforeClose">
                    Cancel
                </button-gray-outline>

                <input-file
                    :store_url="store_route"
                    :parameters="{ folder: selected_folder_id }"
                    :disabled="!selected_folder_id"
                    @uploaded="onFileUploaded"
                >
                    <template slot-scope="{ disabled, selectFile }">
                        <button-blue
                            :disabled="disabled"
                            @click="selectFile"
                        >
                            <div class="flex items-center">
                                <file-icon stroke-width="2" size="14" class="mb-0.5 -ml-1 mr-3" />

                                Select a File
                            </div>
                        </button-blue>
                    </template>
                </input-file>
            </div>
        </div>
    </modal>
</template>

<script>
import ButtonBlue from '../../components/button-blue.vue';
import ButtonGrayOutline from '../../components/button-gray-outline.vue';
import InputFile from '../../components/input-file.vue';
import InputRadioMulti from '../../components/input-radio-multi.vue';
import { FileIcon } from 'vue-feather-icons';

export default {
    components: {
        ButtonBlue,
        ButtonGrayOutline,
        InputFile,
        InputRadioMulti,
        FileIcon,
    },
    props: {
        show: {},
        folders: {},
        property: {},
        store_route: {},
    },

    data() {
        return {
            selected_folder_id: null,
            error: null,
        }
    },

    computed: {
        is_buyer_side() {
            return this.property.deal.our_purchase;
        },
        is_seller_side() {
            return this.property.deal.our_sale;
        },
        filtered_folders() {
            return this.folders.filter(folder => {
                return (this.is_buyer_side && folder.is_buyer_side)
                    || (this.is_seller_side && folder.is_seller_side)
                    || (! folder.is_buyer_side && ! folder.is_seller_side);
            });
        },
        folder_options() {
            return this.filtered_folders.map(folder => ({
                value: folder.id,
                label: folder.name
            }));
        },
    },

    methods: {
        beforeOpen(event) {
            this.selected_folder_id = null;
            this.error = null;
            // Prevent page scrolling when modal is open
            document.body.style.overflow = 'hidden';
        },
        beforeClose(event) {
            // Restore page scrolling when modal is closed
            document.body.style.overflow = '';
            this.$emit('closed');
        },
        onFileUploaded(document) {
            this.$emit('documentUploaded', document);
            this.$emit('expandFolder', this.selected_folder_id);
            this.$modal.hide('document-upload-folder-select-modal');
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show('document-upload-folder-select-modal');
            } else {
                this.$modal.hide('document-upload-folder-select-modal');
            }
        },
    },

    beforeDestroy() {
        // Ensure page scrolling is restored if component is destroyed while modal is open
        document.body.style.overflow = '';
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
